import Gl from '../../../Gl'

import { RenderTarget, Camera, Transform, Orbit, Vec3 } from 'ogl'

export default class Foreground {
  constructor(_params) {
    this.gl = new Gl()

    /* 
      Flags
    */
    this.isRendering = true

    /* 
      Params
    */
    this.params = _params

    /* 
      Scene
    */
    this.scene = new Transform()

    /* 
      Render Target
    */
    this.renderTarget = new RenderTarget(this.gl.renderer.instance.gl, {
      width: this.gl.sizes.width * this.gl.sizes.pixelRatio,
      height: this.gl.sizes.height * this.gl.sizes.pixelRatio,
      type: this.gl.renderer.instance.gl.HALF_FLOAT,
      internalFormat: this.gl.renderer.instance.gl.RGBA16F,
    })
  }

  resize() {
    this.renderTarget.setSize(this.gl.sizes.width * this.gl.sizes.pixelRatio, this.gl.sizes.height * this.gl.sizes.pixelRatio)
  }

  renderPipeline() {
    if (!this.isRendering) return

    this.gl.renderer.instance.render({
      scene: this.scene,
      camera: this.params.camera,
      target: this.renderTarget,
    })
  }

  update() {}
}
